import React, { useEffect } from 'react';

import SlotsContext from './slots-context';

import type { SlotProps } from './types/slots.types';

const Slot: React.FC<SlotProps> = ({ children, name }) => {
  const slotsContext = React.useContext(SlotsContext);

  useEffect(() => {
    if (slotsContext === null) {
      return () => null;
    }

    const { context, registerSlot, unregisterSlot } = slotsContext;

    registerSlot(name, typeof children === 'function' ? children(context) : children);

    return () => {
      unregisterSlot(name);
    };
  }, [name, children, slotsContext]);

  if (slotsContext) {
    return null;
  }

  return typeof children === 'function' ? children({}) : children;
};

export default Slot;
